import Icon from '../components/Icon.vue'

Icon.register({
  'long-arrow-alt-up': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M88 166.1h-46.1c-21.4 0-32.1-25.9-17-41l86.1-86.1c9.4-9.4 24.6-9.4 33.9 0l86.1 86.1c15.1 15.1 4.4 41-17 41h-46.1v301.9c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-301.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/long-arrow-alt-up.js
// module id = 1535
// module chunks = 0